import React, {useMemo, ImgHTMLAttributes} from 'react';

import {getPictureSources} from './utils';
import {TPropsWithClassName} from 'core/types';
import {IGetSourcesParams, TPictureSrcSet} from 'components/Picture/types';

export interface IPictureSource {
    srcSet: string;
    media?: string;
    type?: string;
}

export interface IPictureProps extends ImgHTMLAttributes<HTMLImageElement> {
    sources?: Partial<TPictureSrcSet>;
    mediaMatcher?: Partial<TPictureSrcSet>;
    mimeTypes?: IGetSourcesParams['mimeTypes'];
    crossOrigin?: '' | 'anonymous' | 'use-credentials' | undefined;
    withItemProp?: boolean;
}

const Picture = (props: IPictureProps & TPropsWithClassName) => {
    const {
        sources = {},
        mediaMatcher,
        mimeTypes,
        alt,
        className,
        withItemProp = false,
        fetchPriority,
        ...imageProps
    } = props;

    const renderSources = useMemo<Partial<IPictureSource>[]>(
        () => getPictureSources(sources, mediaMatcher, mimeTypes),
        [sources, mediaMatcher, mimeTypes],
    );

    return (
        <picture className={className}>
            {renderSources?.map((source, index) => {
                const {srcSet, media, type} = source;
                return <source key={index} media={media || undefined} srcSet={srcSet} type={type} />;
            })}

            <img
                {...imageProps}
                alt={alt}
                {...(fetchPriority && {fetchpriority: fetchPriority})}
                {...{itemProp: withItemProp ? 'image' : undefined}}
            />
        </picture>
    );
};
export default Picture;
